export default "__VITE_ASSET__0pxRhv6l__"